export enum SelectionMobileView {
  COMPARATOR = 'comparator',
  DASHBOARD = 'dashboard',
  LIST = 'list',
  MAP = 'map',
}
